import { APIReferenceMemberWithReturns } from '@modules/client';
import React, { FC, useMemo } from 'react';
import { Typography } from '@rbx/ui';
import isTypeOptional from '@modules/utilities/pageBuild/isTypeOptional';
import { useReferenceTypesData } from './ReferenceTypesDataProvider';
import ReferenceMemberType from './ReferenceMemberType';
import useReferenceSummaryMemberTableStyles from './ReferenceSummaryMemberTable.styles';
import useReferenceSummaryMemberTableStylesV2 from './ReferenceSummaryMemberTableV2.styles';

interface ReferenceMemberReturnsProps {
  returns: NonNullable<APIReferenceMemberWithReturns['returns']> | Array<{ type: string }>;
  engineRevampEnabled?: boolean;
}

const ReferenceMemberReturns: FC<React.PropsWithChildren<ReferenceMemberReturnsProps>> = ({
  returns = [],
  engineRevampEnabled = false,
}) => {
  const defaultStyles = useReferenceSummaryMemberTableStyles();
  const v2Styles = useReferenceSummaryMemberTableStylesV2();
  const {
    classes: { parameterComma },
  } = engineRevampEnabled ? v2Styles : defaultStyles;
  const { getTypeAliasDatum } = useReferenceTypesData();
  const returnTypes = useMemo(
    () =>
      returns.map((r) => {
        const aliasData = getTypeAliasDatum(r.type);
        if (!aliasData) throw new Error(`Type alias not found for return: ${JSON.stringify(r)}`);
        return {
          aliasData,
          isOptional: isTypeOptional(r.type),
        };
      }),
    [getTypeAliasDatum, returns],
  );
  return (
    <Typography component='span' variant='body1'>
      {returnTypes.map(({ aliasData, isOptional }, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={i.toString()}>
          <ReferenceMemberType
            parameter={aliasData}
            isOptional={isOptional}
            engineRevampEnabled={engineRevampEnabled}
          />
          {i !== (returns || []).length - 1 && <span className={parameterComma}>,</span>}
        </React.Fragment>
      ))}
    </Typography>
  );
};

export default ReferenceMemberReturns;
